import {getMonth, getYear} from 'date-fns'
import type {PriceChangeReasons} from '../../constants/types'
import type {Addons} from '../../constants/unionV2/addons'
import {ADDON_ASSISTANCE} from '../../constants/unionV2/addons'

export const isAddonSupported = (addon: Addons) => {
  // For now we only allow assistance addon, becasue all other addons cancel free addons,
  // that are automatically included #726.
  // Before allowing other addons, check their conditional parameters and
  // adjust the implementation accordingly.
  if (addon === ADDON_ASSISTANCE) {
    return true
  } else {
    return false
  }
}

export const differenceBetweenRegAndProdIsValid = (registrationDate: string, productionYear: number) => {
  return getYear(new Date(registrationDate)) <= productionYear + 1
}

export const newCarOdometerIsValid = (carIsNew: boolean, odometer: number) => {
  if (!carIsNew) return true

  return odometer <= 50
}

export const isNewCar = (productionYear: number): boolean => {
  const now = new Date()
  const currentYear = getYear(now)
  const currentMonth = getMonth(now)
  return productionYear === currentYear || (productionYear === currentYear - 1 && currentMonth < 2)
}

export const BEGIN_DATE_MAX_DAYS = 90

export const guessPriceChangeReasons = (values: {
  calculation: {
    legalForm?: unknown
    bornNumber?: unknown
    companyNumber?: unknown
    zipCode?: unknown
  }
  draft: {
    legalForm?: string
    bornNumber?: string
    companyNumber?: string
    insurerIsHolder?: boolean
    insurerIsOwner?: boolean
    zipCode?: string
  }
}): PriceChangeReasons => {
  return {
    legalForm: values.calculation.legalForm !== values.draft.legalForm,
    bornNumber: values.calculation.bornNumber !== values.draft.bornNumber,
    companyNumber: values.calculation.companyNumber !== values.draft.companyNumber,
    holder: values.draft.insurerIsHolder === false,
    owner: values.draft.insurerIsOwner === false,
    zipCode: values.calculation.zipCode !== values.draft.zipCode,
  }
}
